import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { PaymentMethods } from "../interface/payment-methods";
import { CustomerService } from "../services/customer.service";
import { ActivatedRoute, Router, Params } from "@angular/router";
@Component({
    selector: "paymentMethods",
    templateUrl: "../templates/template1/views/paymentmethods.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/profile-info.less"
    ],
    providers: [AuthorizationPipe]
})
export class PaymentMethodsComponent implements OnInit {
    sortColumn: string = "cardType";
    sort: String = "DESC";
    pageNumber: number = 1;
    pageSize: number = 10;
    pageCount: number = 0;
    isDesc: boolean = false;

      @Input() distributorId: string;
    distributorAllowedCountries:any[]=[];
    distributorCardPaymentMethods:any[]=[];
    distributorECheckPaymentMethods:any[]=[];
    distributorHomeCountryCode: string = "";
    distributorMemberId: number = 0;
    paymentMethods: PaymentMethods[] = [{ defaultPaymentMethod: true, cardType: 'Visa', cardNumber: 'xxxx1234', expiryDate: '05/22', fullName: 'kumar', note: 'kumar' },
    { defaultPaymentMethod: false, cardType: 'Master', cardNumber: 'xxxx1234', expiryDate: '05/23', fullName: 'kumar', note: 'kumar' }];

    constructor(private _customerservice: CustomerService
        , private route: ActivatedRoute
        , private router: Router) { }

    ngOnInit(): void {
       
       // this._id="001002575619";
     //   this._id=this.distributorId;
      //  this.getPaymentMethods();
        this.getDistributorWithPaymentDetails();
    }
    /**
     * sort table by respective column
     * @param sortColumn 
     */
    sortTableByColumn(sortColumn: string) {
        this.pageNumber = 1;
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? "DESC" : "ASC";
        this.sortColumn = sortColumn;
    }

    getPaymentMethods() {
        this._customerservice.getPaymentMethods(this.distributorId).subscribe(response => {
            if (response) {
                this.paymentMethods = response;
            }
        });
    }
     getDistributorWithPaymentDetails() {
       
        this._customerservice.getMemberDetails(this.distributorId).subscribe(response => {
    
            if (response && response.memberId>0) {
                this.distributorAllowedCountries = response.memberAllowedCountries;
                this.distributorHomeCountryCode= this.distributorAllowedCountries.find(x=>x.homeCountry===true).isoCodeThree;
                this.distributorMemberId=response.memberId;
                this.getDistributorCardPayments(this.distributorHomeCountryCode);
                this.getDistributorECheckPayments(this.distributorHomeCountryCode);
          }
        });
    }

    getDistributorCardPayments(countryCode:any){
      
       this._customerservice.getSavedCardDetails(this.distributorMemberId,countryCode).subscribe(response => {
         
            if (response) {
                this.distributorCardPaymentMethods = response.savedCards;
            }
            else{
                 this.distributorCardPaymentMethods =[];
            }
        });
    }
     getDistributorECheckPayments(countryCode:any){
           
         this._customerservice.getPersonalChecks(this.distributorMemberId,countryCode).subscribe(response => {
         
            if (response) {
                this.distributorECheckPaymentMethods = response;
            }else{
                  this.distributorECheckPaymentMethods = [];
            }
        });
    }

    onCountryChangeEvent(event:any){
     
       if(event){
           this.getDistributorCardPayments(event);
           this.getDistributorECheckPayments(event);
       }

    }

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/paymentmethods.component.ts